export default "__VITE_ASSET__DXIEEKzX__"